import type {ConnectElementConfig} from '../ConnectElementList';

export const CapitalPageConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "capitalPage" */
      '../../../components/Capital/CapitalPage/CapitalPage'
    ),
  releaseState: 'internal',
  sentryTeam: 'capital_for_platforms',
  teamOwner: 'capital-for-platforms',
  description:
    'Combines Capital financing promotion and financing reporting into one page that follows the account through the offer, application, review, active, and past financing states.',
  friendlyName: 'Capital page',
};
